import { Drawer } from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { breakpoints } from '../../../../theme/breakpoints'
import ListServiceProvider from '../../../../services/ListServiceProvider'
import { create as createNiceModal, useModal } from '@ebay/nice-modal-react'
import { AddPartsToList } from './AddPartsToList'
import { AddNewList } from './AddNewList'
import { ProductModel } from 'interfaces'

interface IAddToListDrawer {
  product: ProductModel
  currentQty: number
}

export const AddToListDrawer = createNiceModal<IAddToListDrawer>(
  ({ product, currentQty }): ReactElement => {
    const modal = useModal()
    const [categories, setCategories] = useState([])
    const [showAddNewListDrawer, setShowAddNewListDrawer] = useState(false)

    useEffect(() => {
      getCategories()
    }, [])

    const getCategories = async (): Promise<void> => {
      const { categories } = await ListServiceProvider.getCategoriesAndLists()
      const temp = categories.map((cat) => {
        return {
          ...cat,
          value: cat.name,
          lists: cat.lists.map((list) => {
            return {
              ...list,
              value: list.name,
            }
          }),
        }
      })
      setCategories(temp)
    }

    const handleClose = (): void => {
      modal.remove()
    }

    const handleAddNewList = (): void => {
      setShowAddNewListDrawer(true)
    }

    const handleBack = (): void => {
      setShowAddNewListDrawer(false)
    }

    const isTablet = window.innerWidth < breakpoints.tablet

    return (
      <Drawer
        anchor={isTablet ? 'bottom' : 'right'}
        open={modal.visible}
        onClose={handleClose}
      >
        {!showAddNewListDrawer ? (
          <AddPartsToList
            categories={categories}
            selectedProduct={product}
            totalQty={currentQty}
            handleClose={handleClose}
            handleAddNewList={handleAddNewList}
          ></AddPartsToList>
        ) : (
          <AddNewList
            categories={categories}
            selectedProduct={product}
            totalQty={currentQty}
            handleBack={handleBack}
            handleClose={handleClose}
          ></AddNewList>
        )}
      </Drawer>
    )
  }
)
